export default "__VITE_ASSET__660ee536__"